import { navItems } from "@/mocks/movieData";

const quickLinks = [
  { id: "fl-1", label: "查看最新地址", href: "#lines" },
  { id: "fl-2", label: "多端使用对比", href: "#devices" },
  { id: "fl-3", label: "片单速览", href: "#titles" },
  { id: "fl-4", label: "常见问题", href: "#faq" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 pt-12 md:pt-16">
        <div className="rounded-lg bg-primary-500 text-background-50 px-6 md:px-10 py-8 md:py-12 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="font-heading text-xl md:text-3xl font-bold leading-snug">
              先确认线路，再开始观看
            </h2>
            <p className="mt-3 text-sm md:text-base opacity-95 leading-relaxed">
              入口信息会随网络环境变化而调整。把本页加入收藏，之后遇到打不开的情况，回到这里按当前状态选择线路即可。
            </p>
          </div>
          <a
            href="#lines"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-700 text-sm md:text-base font-label whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer shrink-0"
          >
            <i className="ri-link-m" aria-hidden="true"></i>
            查看最新地址
          </a>
        </div>
      </div>

      <div className="mt-12 md:mt-16 bg-secondary-950 text-background-100">
        <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-14">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div className="md:col-span-1">
              <div className="flex items-center gap-2 font-heading font-bold text-lg text-background-50">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-film-line text-base" aria-hidden="true"></i>
                </span>
                神马电影
              </div>
              <p className="mt-4 text-sm text-background-300 leading-relaxed">
                一个整理观影入口与使用说明的导航页面，帮助你快速找到可用的官网入口、最新地址与 APP 下载方式。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-base font-bold text-background-50">页面分区</h3>
              <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
                {navItems.map((item) => (
                  <li key={item.id}>
                    <a
                      href={item.href}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-bold text-background-50">常用入口</h3>
              <ul className="mt-4 space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors inline-flex items-center gap-1.5"
                    >
                      <i className="ri-arrow-right-s-line text-accent-400" aria-hidden="true"></i>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <p className="text-xs text-background-400">
              © 2026 神马电影 导航说明页 · 内容为入口信息整理与一般性使用说明
            </p>
            <p className="text-xs text-background-400">
              本页不存储任何影视内容，仅提供访问方式的说明与导航。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}